import { render } from "./TransactionDialog.vue?vue&type=template&id=07891138&scoped=true"
import script from "./TransactionDialog.vue?vue&type=script&lang=js"
export * from "./TransactionDialog.vue?vue&type=script&lang=js"

import "./TransactionDialog.vue?vue&type=style&index=0&id=07891138&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07891138"]])

export default __exports__